var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaFacebookSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "faFacebookSquare"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 2C3.79375 2 2 3.79375 2 6V26C2 28.2062 3.79375 30 6 30H12.1375V20.8875H8.8375V16H12.1375V13.8938C12.1375 8.45 14.6 5.925 19.95 5.925C20.9625 5.925 22.7125 6.125 23.4312 6.325V10.75C23.0562 10.7125 22.4 10.6875 21.5812 10.6875C18.9562 10.6875 17.9438 11.6812 17.9438 14.2625V16H23.1688L22.2687 20.8875H17.9375V30H26C28.2062 30 30 28.2062 30 26V6C30 3.79375 28.2062 2 26 2H6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaFacebookSquare);
export default __webpack_public_path__ + "static/media/faFacebookSquare.bf920ef3b5475f105b830a7b528fd56b.svg";
export { ForwardRef as ReactComponent };